import React from 'react';
import { SliderStyled } from './RangeSlider.styles';
import { Mark, SliderProps } from '@material-ui/core';

type Props = {
  value?: number[];
  color?: string;
  step?: number;
  marks?: Mark[];
  disabled?: boolean;
  keepDesktopLayout?: boolean;
} & SliderProps;

const RangeSlider: React.FC<Props> = ({
  value,
  color = '#3e8bff',
  step,
  marks,
  disabled = false,
  onChange,
  keepDesktopLayout,
  ...props
}) => {
  return (
    <SliderStyled
      {...props}
      // ThumbComponent={Icon}
      keepDesktopLayout={keepDesktopLayout}
      step={step}
      marks={marks}
      valueLabelDisplay="off"
      aria-label="range slider"
      value={value}
      disabled={disabled}
      style={{
        color: color ? color : '#52af77',
      }}
      onChange={onChange}
    />
  );
};

export default RangeSlider;
